import {Theme, styled} from "@mui/material";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import { CustomerFormData } from "../customer-model";
import Divider from "@mui/material/Divider";
import { DynamicRecaptcha } from "../../recaptcha/DynamicRecaptcha";
import EditIcon from "@mui/icons-material/Edit";
import { ErrorBox } from "../support/ErrorBox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { FormikProps } from "formik";
import IconButton from "@mui/material/IconButton";
import Link from "next/link";
import { CustomerSummaryData as Type } from "../customer-model";
import Typography from "@mui/material/Typography";
import { useSiteKey } from "../../recaptcha/useSiteKey";
import { useTranslation } from "next-i18next";

const termsAndConditionsUrl = "https://www.cargill.com/page/website-terms";

interface Props {
  formData: CustomerFormData;
  formik: FormikProps<Type>;
  handleSetStep: any;
}

const StyledIconButton = styled(IconButton)(
  ({ theme }: { theme: Theme }) => ({
    "& svg": {
      color: theme.palette.lightBlue[70],
      width: "24px",
      height: "24px",
    },
  }),
);

/**
 * RequestReason step / screen.
 */
export function CustomerConfirmationStep({ formData, formik, handleSetStep }: Props) {
  const { t, i18n } = useTranslation();
  const sitekey = useSiteKey();

  /**
   * Set the reCAPTCHA token
   */
  function setRecaptchaToken(token: any) {
    if (token && token.length > 0) {
      formik.setFieldValue("accessToken", token);
    } else {
      formik.setFieldValue("accessToken", "");
    }
  }

  /**
   * Clear the reCAPTCHA token
   */
  function clearRecaptchaToken() {
    formik.setFieldValue("accessToken", "");
  }

    /**
   * set stepper to selected option
   */
    const handlingEditoption=(appName:string, targetIndex:number,defaultIndex:number) => {
      if(appName === formData.appRefName){
        handleSetStep(targetIndex)
      }else{
        handleSetStep(defaultIndex)
      }
    }

  /**
   * Get key words to check if it is a HR request
   */

  return (
    <Box>
      <Box
        sx={{
          marginBottom: "20px",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "1.75em",
            alignSelf: "center",

            fontWeight: "bold",
          }}
        >
          {t("request_access:customer_access.request_summary")}
        </Typography>
      </Box>
      <Box sx={{ mt: "24px", mb: "12px", textAlign: "left" }}>
        <Typography align="center">
          {t("request_access:customer_access.request_summary_header")}
        </Typography>
        <Typography align="center">
          {t("request_access:customer_access.request_summary_description")}
        </Typography>
      </Box>

      <Box sx={{ mt: "24px", mb: "12px", textAlign: "left" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            sx={{
              fontSize: "1em",
              alignSelf: "center",

              fontWeight: "bold",
            }}
          >
            {t("request_access:customer_access.contact_information")}
          </Typography>
          <StyledIconButton aria-label="edit"   onClick={()=>{handlingEditoption("FIBI", 3,2)}}>
            <EditIcon />
          </StyledIconButton>
        </Box>
        <Divider />
        <Typography>
          {formData.firstName} {formData.lastName}
        </Typography>
        <Typography>{formData.role}</Typography>
        <Typography>{formData.email}</Typography>
        <Typography>{formData.phoneNumber}</Typography>
      </Box>
      <Box sx={{ mt: "24px", mb: "12px", textAlign: "left" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            sx={{
              fontSize: "1em",
              alignSelf: "center",

              fontWeight: "bold",
            }}
          >
            {t("request_access:customer_access.business_information")}
          </Typography>
          <StyledIconButton aria-label="edit"  onClick={()=>{handlingEditoption("FIBI", 4,3)}}>
            <EditIcon />
          </StyledIconButton>
        </Box>

        <Divider />
        <Typography>{formData.companyName}</Typography>
        <Typography>{formData.countryOfBusiness}</Typography>
        <Typography>{formData.address}</Typography>
        <Typography>
          {formData.city}, {formData.state}, {formData.zipCode}
        </Typography>
      </Box>
      <Box sx={{ mt: "24px", mb: "12px", textAlign: "left" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            sx={{
              fontSize: "1em",
              alignSelf: "center",

              fontWeight: "bold",
            }}
          >
            {t("request_access:more_information.requested_portal")}
          </Typography>
          <StyledIconButton aria-label="edit"  onClick={()=>{handlingEditoption("FIBI", 0,0)}}>
            <EditIcon />
          </StyledIconButton>
        </Box>
        <Divider />
        <Typography>{formData.cargillBusiness}</Typography>
      </Box>
      <Box sx={{ mt: "24px", mb: "12px", textAlign: "left" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            sx={{
              fontSize: "1em",
              alignSelf: "center",

              fontWeight: "bold",
            }}
          >
            {t("request_access:more_information.reason_for_request")}
          </Typography>
          <StyledIconButton aria-label="edit"   onClick={()=>{handlingEditoption("FIBI", 1,1)}}>
            <EditIcon />
          </StyledIconButton>{" "}
        </Box>

        <Divider />
        {formData.requestReasons.length > 0 ? (
          formData.requestReasons.map((reason: string, index: number) => (
            <Typography key={index}>{reason}</Typography>
          ))
        ) : (
          <Typography>{formData.requestReason}</Typography>
        )}
      </Box>
      {formData.businessUnits.length > 0 && formData.appRefName.toUpperCase() === "FIBI" ? (
        <Box sx={{ mt: "24px", mb: "12px", textAlign: "left" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignContent: "center",
            }}
          >
            <Typography
              sx={{
                alignSelf: "center",
                fontSize: "1em",
                fontWeight: "bold",
              }}
            >
              {t("request_access:customer_access.business_unit")}
            </Typography>
            <StyledIconButton aria-label="edit"  onClick={()=>{handlingEditoption("FIBI", 2,2)}}>
              <EditIcon />
            </StyledIconButton>{" "}
          </Box>

          <Divider />

          {formData.businessUnits.map((bunit: string, index: number) => (
            <Typography key={index}>{bunit}</Typography>
          ))}
        </Box>
      ):<></>}

      <form onSubmit={formik.handleSubmit}>
        {/* Accept Terms and Conditions */}
        <Box sx={{ paddingTop: "24px" }}>
          <FormGroup>
            <FormControlLabel
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              control={
                <Checkbox
                  onChange={formik.handleChange}
                  id="agreeToTerms"
                  name="agreeToTerms"
                  value={formik.values.agreeToTerms}
                />
              }
              label={
                <>
                  {t("request_access:more_information.agree_to")}{" "}
                  <Link href={termsAndConditionsUrl} target="_blank">
                    {t("request_access:more_information.terms_and_conditions")}
                  </Link>
                </>
              }
            />
          </FormGroup>
          {formik.errors.agreeToTerms && formik.touched.agreeToTerms && (
            <ErrorBox>{formik.errors.agreeToTerms}</ErrorBox>
          )}
        </Box>

        {/* reCAPTCHA */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "32px",
            marginBottom: "16px",
          }}
        >
          <DynamicRecaptcha
            sitekey={sitekey}
            language={i18n.language}
            onChange={setRecaptchaToken}
            onExpired={clearRecaptchaToken}
          />
        </Box>

        <Box mt={12}>
          <Button
            sx={{ width: "100%", mb: 4 }}
            type="submit"
            disabled={!(formik.dirty && formik.isValid)}
          >
            {t("request_access:more_information.submit_request")}
          </Button>
        </Box>
      </form>
    </Box>
  );
}
